module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/Zarautz-d5a7e0179e6ca9a6b68b4060de13cb12.jpg";